import React from 'react'

import '../terminal.css';
import '../fonts/Terminal.woff';
import YoutubeEmbed from '../Components/youtube.jsx';
import Box from '../Components/box.jsx';
import { useEffect } from 'react';

const textStyle = {color:"#00ff00", margin:0, marginBottom:"15px", fontFamily: "Terminal", fontSize:30, letterSpacing:"2px", opacity:0.9, float:"left", textAlign:"left"}
const smallTextStyle = {...textStyle, fontSize:16}
const smallerTextStyle = {...textStyle, fontSize:14}

const RoboAbout = ({mainBoxHeight, mainBoxWidth}) => {

	useEffect(() => {
		document.title = 'ROBOTRON - About';
	}, []);

	const youtubeHeight = Math.min(560, (mainBoxHeight-160)/2)

	return <>
		<Box height={youtubeHeight} width={mainBoxWidth-60} down={100} style={{paddingTop:20}} corner={0}>            
			<YoutubeEmbed embedId="0QCZcllw49Y" height={youtubeHeight} autoplay={true} colour={"0, 255, 0, 0.8"}/>
		</Box>
		<Box height={mainBoxHeight-180-youtubeHeight} width={mainBoxWidth-60} corner={0} down={youtubeHeight+100} style={{paddingTop:20}}>
			<div style={{overflowY:"scroll", height:mainBoxHeight-220-youtubeHeight}}>            
				<p style={textStyle}>
					<h4><strong>ROBOTRON</strong> journey into the UNKNOWN.</h4>
				</p>

				<p style={smallTextStyle}>
				The world is a proper mess. And it's only got worse since you fell at the hands of <strong>Rocke T Ron</strong> five years ago. The split criminal factions are now fighting for control in the new power vacuum. But you've awaken, mysteriously, online and in tact somehow. And you, <strong>Robotron</strong>, must set things right as you emerge and venture through this broken digital realm, returning to Dr. G Person's reactor where you once fell. 
				</p>
				<p style={smallTextStyle}>
				Robotron is a top down shooter. You can usually only take one shot before you die. But you have many lives and will be brought back to live again instantly. Until you run out. But just hit the R key and try again. And if it's still too hard, try another game mode until you get better. 
				</p>
				<div style={smallerTextStyle}>
				<ul>
					<li>
						<p>Multiple levels and different game mode stages.</p>
					</li>
					<li>
						<p>Many super power ups to help you fight. </p>
					</li>
					<li>
						<p>A production line of dangerous foes. </p>
					</li>
					<li>
						<p>Formidable bosses. </p>
					</li>
					<li>
						<p>And entirely original sound design from sound effects to musical soundtracks.</p>
					</li>
					<li>
						<p>An online high score for you to dominate. </p>
					</li>
					<li>
						<p>Much to unlock. </p>
					</li>
					<li>
						<p>Easy to understand, difficult and rewarding to master. </p>
					</li>
					<li>
						<p>The continuation of the Rocketron universe. </p>
					</li>
					<li>
						<p>And yet much more yet <strong>UNKNOWN</strong>. </p>
					</li>
				</ul>
				</div>
	

			</div>
			<div class="row" style={{...smallerTextStyle, margin:"auto", width:"100%"}}>
				<div class="column" style={{width:"20%"}}><a href="https://kadormazing.itch.io/robotron">itch.io</a></div>
				<div class="column" style={{width:"20%"}}><a href="https://discord.com/invite/wjVHhgGxj6">Discord</a></div>
				<div class="column" style={{width:"20%"}}><a href="https://www.youtube.com/@ShrivelledHeartSoftware">YouTube</a></div>
				<div class="column" style={{width:"20%"}}><a href="https://www.indiedb.com/games/killing-machine-movement">Indie DB</a></div>
			</div>

		</Box>
		
	</>

}

export default RoboAbout